import * as SharedProcess from '../SharedProcess/SharedProcess.js'
import * as PlatformType from '../PlatformType/PlatformType.js'
/* istanbul ignore file */

// TODO this should always be completely tree shaken out during build, maybe need to be marked as @__Pure for terser to work

// TODO treeshake this function out when targeting electron

export const isMobileOrTablet = () => {
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return false
  }
  // @ts-ignore
  const userAgentData = navigator.userAgentData
  if (userAgentData && userAgentData.mobile === true) {
    return true
  }
  // copied from https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
  let check = false
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[23]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.slice(0, 4)
      )
    ) {
      check = true
    }
    // @ts-ignore
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

const getIsChrome = () => {
  if (typeof navigator === 'undefined') {
    return false
  }
  if (
    // @ts-ignore
    navigator.userAgentData &&
    // @ts-ignore
    navigator.userAgentData.brands
  ) {
    // @ts-ignore
    return navigator.userAgentData.brands.includes('Chromium')
  }
  return false
}

export const isChrome = getIsChrome()

const getIsFirefox = () => {
  if (typeof navigator === 'undefined') {
    return false
  }
  if (
    // @ts-ignore
    navigator.userAgentData &&
    // @ts-ignore
    navigator.userAgentData.brands
  ) {
    // @ts-ignore
    return navigator.userAgentData.brands.includes('Firefox')
  }
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
}

export const isFirefox = getIsFirefox()

export const getExtensionsPath = () => {
  return SharedProcess.invoke(
    /* Platform.getExtensionsPath */ 'Platform.getExtensionsPath'
  )
}

export const getBuiltinExtensionsPath = () => {
  return SharedProcess.invoke(
    /* Platform.getBuiltinExtensionsPath */ 'Platform.getBuiltinExtensionsPath'
  )
}

export const getDisabledExtensionsPath = () => {
  return SharedProcess.invoke(
    /* Platform.getDisabledExtensionsPath */ 'Platform.getDisabledExtensionsPath'
  )
}

export const getCachedExtensionsPath = () => {
  return SharedProcess.invoke(
    /* Platform.getCachedExtensionsPath */ 'Platform.getCachedExtensionsPath'
  )
}

export const getMarketPlaceUrl = () => {
  // TODO this should be configurable via settings
  // TODO in web this should be static
  return SharedProcess.invoke(
    /* Platform.getMarketPlaceUrl */ 'Platform.getMarketplaceUrl'
  )
}

export const getLogsDir = () => {
  return SharedProcess.invoke(/* Platform.getLogsDir */ 'Platform.getLogsDir')
}

export const getUserSettingsPath = () => {
  if (platform === PlatformType.Web) {
    return 'settings'
  }
  return SharedProcess.invoke(
    /* Platform.getUserSettingsPath */ 'Platform.getUserSettingsPath'
  )
}

/**
 * @returns {'electron'|'remote'|'web'|'test'}
 */
const getPlatform = () => {
  // @ts-ignore
  if (typeof PLATFORM !== 'undefined') {
    // @ts-ignore
    return PLATFORM
  }
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return 'test'
  }
  if (typeof location !== 'undefined' && location.search === '?web') {
    return PlatformType.Web
  }
  if (
    typeof location !== 'undefined' &&
    location.search.includes('platform=electron')
  ) {
    return PlatformType.Electron
  }
  return PlatformType.Remote
}

export const platform = 'remote'

export const getAssetDir = () => {
  // @ts-ignore
  if (typeof '/f7c00d2' !== 'undefined') {
    // @ts-ignore
    return '/f7c00d2'
  }
  if (platform === PlatformType.Electron) {
    return '../../../../..'
  }
  return ''
}

export const getRecentlyOpenedPath = () => {
  if (platform === PlatformType.Web) {
    return 'recently-opened'
  }
  return SharedProcess.invoke(
    /* Platform.getRecentlyOpenedPath */ 'Platform.getRecentlyOpenedPath'
  )
}

export const getConfigPath = () => {
  return SharedProcess.invoke(
    /* Platform.getConfigDir */ 'Platform.getConfigDir'
  )
}

export const getCachePath = () => {
  return SharedProcess.invoke(/* Platform.getCacheDir */ 'Platform.getCacheDir')
}

export const getExtensionHostWorkerUrl = () => {
  const assetDir = getAssetDir()
  return `${assetDir}/packages/extension-host-worker/dist/extensionHostWorkerMain.js`
}

export const getGithubApiUrl = () => {
  return `https://api.github.com`
}

export const getCacheName = () => {
  return 'lvce-runtime'
}

const getTestPathRemote = () => {
  return SharedProcess.invoke(/* Platform.getTestPath */ 'Platform.getTestPath')
}

const getTestPathWeb = () => {
  return '/packages/extension-host-worker-tests'
}

export const getTestPath = () => {
  switch (platform) {
    case PlatformType.Electron:
    case PlatformType.Remote:
      return getTestPathRemote()
    case PlatformType.Web:
      return getTestPathWeb()
  }
}

export const getNodePath = () => {
  if (platform === PlatformType.Web) {
    throw new Error('not implemented in web')
  }
  return SharedProcess.invoke(/* Platform.getNodePath */ 'Platform.getNodePath')
}

export const getTmpDir = () => {
  if (platform === PlatformType.Web) {
    throw new Error('not implemented in web')
  }
  return SharedProcess.invoke(/* Platform.getTmpDir */ 'Platform.getTmpDir')
}
